'use client'

import { Button } from '@/core/components/form/button/button'
import { LuX } from 'react-icons/lu'

import { closeTop, openModal } from '@/features/veluvit/stores/overlay.store'

/** 대화 장면 전체보기 — 화면 전체에 원본 비율로 (v2-chat.js openImage) */
function ImageViewer({ src }: { src: string }) {
  return (
    <div className="fixed inset-0 grid grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden bg-black/90 text-white backdrop-blur-2xl">
      <div className="flex items-center gap-3 px-4 pt-[max(12px,var(--safe-top))] pb-2.5 text-c13">
        <strong className="flex-1 font-semibold">대화 장면</strong>
        <Button
          type="button"
          aria-label="전체보기 닫기"
          onClick={() => closeTop()}
          className="grid size-10.5 cursor-pointer place-items-center rounded-full bg-foreground/10 text-white shadow-[inset_0_0_0_1px_rgb(255_255_255/0.1),inset_0_1px_0_rgb(255_255_255/0.08)] backdrop-blur-md transition-colors hover:bg-foreground/15 focus-visible:bg-foreground/15"
          variant="bare"
        >
          <LuX aria-hidden="true" className="size-5" />
        </Button>
      </div>
      <div className="flex min-h-0 min-w-0 items-center justify-center px-3">
        {/* 장면 컷마다 비율이 달라 원본 그대로 보여 준다 */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={src}
          alt="대화 장면 전체 이미지"
          className="block size-full min-h-0 min-w-0 object-contain"
        />
      </div>
      <div className="px-4 pt-2.5 pb-[max(14px,env(safe-area-inset-bottom))] text-center text-c12 text-t3">
        대화 장면 전체 이미지
      </div>
    </div>
  )
}

export function openImageViewer(src: string) {
  openModal(<ImageViewer src={src} />, {
    bare: true,
    label: '대화 장면 전체보기',
  })
}
